import React from "react";
import { FormHelperText } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { observer } from "mobx-react";
import { Editor } from "../quillTextEditor/Editor";
import { Colors } from "../color/Colors";

export const RichTextArea = observer(({
  data,
  dataWithStyles,
  isNeedShowTable = false,
}: {
  data: string,
  dataWithStyles: string,
  isNeedShowTable?: boolean,
}) => {
  let currentText = dataWithStyles || data || ''
  if (!isNeedShowTable) {
    currentText = currentText.replace(/<figure class="table">(.*?)<\/figure>/g, '*ТАБЛИЦА*');
  }
  const classes = useStyles({ minHeight: '' });
  return (
    <>
      <div
        style={{ lineHeight: '1.2' }}
        className={classes.richTextAreaTable}
        dangerouslySetInnerHTML={{ __html: currentText }}
      />
    </>
  )
})

export const RichTextEditor = observer((
  {
    defaultInputValue = '',
    changeHandler,
    minHeight = '0%',
    disabled = false,
    error = '',
    toolbarProps: _toolbarProps = [],
  }: {
    defaultInputValue?: string,
    changeHandler: any,
    minHeight?: string,
    disabled?: boolean,
    error?: string,
    toolbarProps?: string[],
  }
) => {
  const classes = useStyles({ minHeight: minHeight });

  const htmlToPlainText = (html: string) => {
    let plainText = html || '';
    plainText = plainText.replace(/&nbsp;/ig, ' ');
    plainText = plainText.replace(/<figure class="table">(.*?)<\/figure>/g, '*ТАБЛИЦА*\n');
    plainText = plainText.replace(/<style([\s\S]*?)<\/style>/gi, '');
    plainText = plainText.replace(/<script([\s\S]*?)<\/script>/gi, '');
    plainText = plainText.replace(/<\/div>/ig, '\n');
    plainText = plainText.replace(/<\/li>/ig, '\n');
    plainText = plainText.replace(/<li>/ig, '  *  ');
    plainText = plainText.replace(/<\/ul>/ig, '\n');
    plainText = plainText.replace(/<\/p>/ig, '\n');
    plainText = plainText.replace(/<br\s*[\/]?>/gi, "\n");
    plainText = plainText.replace(/<[^>]+>/ig, '');
    return plainText;
  };

  const normalizedDefaultValue = htmlToPlainText(defaultInputValue || '');

  const handleChange = async (htmlValue: string) => {
    const plainText = htmlToPlainText(htmlValue);
    await changeHandler(htmlValue, plainText);
  }
  return (
    <>
      <div className={classes.textEditor} style={{ minHeight: minHeight }}>
        <Editor
          defaultValue={normalizedDefaultValue}
          readOnly={disabled}
          onTextChange={(htmlValue) => {
            handleChange(htmlValue);
          }}
        />
        <FormHelperText error={!!error}>{error}</FormHelperText>
      </div>
    </>
  )
})

const useStyles = makeStyles(() => ({
  textEditor: (props: { minHeight: string }) => ({
    '& .ql-toolbar, & .ql-container': {
      backgroundColor: `${Colors.bg} !important`,
    },
    '& .ql-editor': {
      minHeight: props.minHeight
    },
  }),
  richTextAreaTable: {
    '& table, th, td': {
      border: '1px solid ',
      borderCollapse: 'collapse',
      padding: '6px'
    }
  }
}));
